export default "__VITE_ASSET__7f131f45__"